
import Api from '@/utils/api';
import MHeader from '../Header/Header.vue';
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
components: {
MHeader,
XInput,
Group,
XButton,
Cell
},
data() {
return {
mobileNumber: "",
smsCode: "",
countingNumber: 0
}
},
methods: {
sendSMSCode() {
if (!this.mobileNumber) {
this.$vux.toast.text('请输入手机号码')
return
}
Api.sendSMSCode({
mobileNumber: this.mobileNumber
}).then(res => {
this.$store.commit('updateToast', {
show: true,
text: '短信验证码发送成功, 5分钟内有效!'
});
this.countingNumber = 60
let self = this;
let timer = null;
if (self && !self._isDestroyed) {
timer = setInterval(() => {
if (self && !self._isDestroyed) {
this.countingNumber--
if (this.countingNumber < 1) {
clearInterval(timer)
}
}
}, 1000);
}
})
},
bindMobileNumber() {
if (!this.mobileNumber) {
this.$vux.toast.text('请输入手机号码')
return
}
if (!this.smsCode) {
this.$vux.toast.text('请输入验证码')
return
}
console.log(this.$store.state.userInfo.mobileNumber)
Api.bindMobileNumber({
mobileNumber: this.mobileNumber,
smsCode: this.smsCode
}).then(res => {
this.$store.dispatch('loadUserInfo')
.then(() => {
this.$store.commit('updateToast', {
show: true,
text: '绑定手机号码成功'
});
this.$router.go(-1);
})
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/bindMobileNumber.vue